// app-link.js

function getDeviceType() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    
   if (/iPhone|iPad|iPod/i.test(userAgent) ||
                    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1))  return "ios";
  if (/Android|adr/i.test(userAgent)) return "android";
  if (/Win/i.test(navigator.platform)) return "windows";
  if (/Mac/i.test(navigator.platform)) return "mac";
  if (/Linux/i.test(navigator.platform)) return "linux";
  return "unknown";


  
}

function getAppLink() {
  const device = getDeviceType();

  if (device === "android") {
    return "https://play.google.com/store/apps/details?id=com.cyberboss";
  } else if (device === "ios") {
    return "https://apps.apple.com/in/app/kyora-iq/id6749854798";
  } else {
    // fallback for desktop
    return "https://play.google.com/store/apps/details?id=com.cyberboss";
  }
}

// ✅ Dynamic assigner function (usable anywhere)
function setAppLinks() {
  const appLink = getAppLink();

  // Target all buttons with the data attribute
  document.querySelectorAll("[data-app-link]").forEach(btn => {
    btn.setAttribute("href", appLink);
    btn.setAttribute("target", "_blank"); // optional
  });
}

document.addEventListener("DOMContentLoaded", setAppLinks);
